import { useQuery } from '@tanstack/react-query';
import { IWorkPhase } from '@publishing-engine/domain/models';

import { fetchSubmissionChecklist } from '../api/queries';

export default function useEditorialForm(
  submissionId: string,
  submissionContextId: string,
  organizationId: string,
  phase: IWorkPhase,
  articleWorkflowId?: string
) {
  const { data, isLoading } = useQuery({
    queryKey: [
      'submission-checklist',
      { submissionId, phase, articleWorkflowId }
    ],
    queryFn: () =>
      fetchSubmissionChecklist(
        submissionId,
        submissionContextId,
        organizationId,
        phase,
        articleWorkflowId
      ),
    enabled: !!submissionContextId && !!submissionId && !!organizationId
  });

  // generate default value for form fields
  const defaultFormValues: Record<string, boolean> =
    data?.editorialFormSchema?.formFields?.reduce(
      (acc: Record<string, boolean>, { name }) => {
        return { ...acc, [name as string]: false };
      },
      {}
    ) || {};

  const {
    editorialFormData = { caseData: defaultFormValues },
    editorialFormSchema
  } = data || {};

  return {
    editorialFormSchema,
    editorialFormData,
    isLoading,
    defaultFormValues
  };
}
